import { CreditInsights } from './credit-insights';
import { Scores } from './scores';

export interface AnalysisParametersPeriod {
  mode?: AnalysisConfigurationMode;
  numberOfDays?: number;
  numberOfMonths?: number;
  useBalanceDate?: boolean;
  relaunch?: boolean;
}

export interface AnalysisParameters {
  disableScores?: boolean;
  disableCreditInsights?: boolean;
  period?: AnalysisParametersPeriod;
}

export interface AnalysisCalendar {
  month: string;
  nbDays: number;
}

export interface ProductMetadata {
  calendar: AnalysisCalendar[];
  firstTransactionDate: string;
  historicalDepth: number;
  lastTransactionGap: number;
  monthlyTransactionCount: number;
  totalTransactionCount: number;
  minWindowDate?: string;
  maxWindowDate?: string;
  numberOfDaysInWindow?: number;
}

export interface AnalysisMetadata {
  creditInsights?: ProductMetadata;
  paymentScore?: ProductMetadata;
  creditScore?: ProductMetadata;
  // @deprecated
  calendar?: AnalysisCalendar[];
  // @deprecated
  firstTransactionDate?: string;
  // @deprecated
  historicalDepth?: number;
  // @deprecated
  lastTransactionGap?: number;
  // @deprecated
  monthlyTransactionCount?: number;
  numberOfCheckings: number;
  numberOfCreditCard: number;
  numberOfLoans: number;
  numberOfSavings: number;
  // @deprecated
  totalTransactionCount?: number;
  referenceDate?: string;
  activityScore?: {
    value: number;
  };
}

export enum AnalysisSource {
  INTERNAL = 'INTERNAL',
  CLIENT = 'CLIENT',
  REFRESH = 'REFRESH',
  REFRESH_WITH_NEW_ACCOUNTS = 'REFRESH_WITH_NEW_ACCOUNTS',
  PERIOD_UPDATE = 'PERIOD_UPDATE',
}

export enum AnalysisStatus {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}
export enum AnalysisErrorCodes {
  NOT_ENOUGH_TRANSACTIONS = 'NOT_ENOUGH_TRANSACTIONS',
  USAGE_NOT_SUPPORTED = 'USAGE_NOT_SUPPORTED',
  CURRENCY_NOT_SUPPORTED = 'CURRENCY_NOT_SUPPORTED',
  NON_UNIQUE_ACCOUNT = 'NON_UNIQUE_ACCOUNT',
  UNICITY_CHECK = 'UNICITY_CHECK',
  NO_CHECKING_ACCOUNT = 'NO_CHECKING_ACCOUNT',
  NO_ANALYZABLE_ACCOUNT = 'NO_ANALYZABLE_ACCOUNT',
  MORE_THAN_3_OWNERS = 'MORE_THAN_3_OWNERS',
  ACCOUNT_TYPE_NOT_SUPPORTED = 'ACCOUNT_TYPE_NOT_SUPPORTED',
  OWNERSHIP_NOT_SUPPORTED = 'OWNERSHIP_NOT_SUPPORTED',
  LOW_ACTIVITY_SCORE = 'LOW_ACTIVITY_SCORE',
  ZERO_INCOME = 'ZERO_INCOME',
}

export enum LastFailedAnalysisErrorCodes {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  NOT_ENOUGH_TRANSACTIONS = 'NOT_ENOUGH_TRANSACTIONS',
  CURRENCY_NOT_SUPPORTED = 'CURRENCY_NOT_SUPPORTED',
  USAGE_NOT_SUPPORTED = 'USAGE_NOT_SUPPORTED',
  NO_CHECKING_ACCOUNT = 'NO_CHECKING_ACCOUNT',
  ACCOUNT_TYPE_NOT_SUPPORTED = 'ACCOUNT_TYPE_NOT_SUPPORTED',
  OWNERSHIP_NOT_SUPPORTED = 'OWNERSHIP_NOT_SUPPORTED',
  AGGREGATION_FAILED = 'AGGREGATION_FAILED',
  LOW_ACTIVITY_SCORE = 'LOW_ACTIVITY_SCORE',
  ZERO_INCOME = 'ZERO_INCOME',
}

export enum StateFamily {
  FLOW_STARTED = 'FLOW_STARTED',
  AGGREGATION_STARTED = 'AGGREGATION_STARTED',
  IN_ERROR = 'IN_ERROR',
  VOID = 'VOID',
  PENDING = 'PENDING',
  HAS_ANALYSIS = 'HAS_ANALYSIS',
  ANALYSIS_SUCCESS_PDF = 'ANALYSIS_SUCCESS_PDF',
  PENDING_PDF = 'PENDING_PDF',
  IN_ERROR_PDF = 'IN_ERROR_PDF',
}

export interface AnalysisError {
  code: AnalysisErrorCodes;
  message: string;
}

export interface Analysis {
  id: string;
  createdAt: string;
  updatedAt: string;
  parameters?: AnalysisParameters;
  metadata?: AnalysisMetadata;
  source?: AnalysisSource;
  status: AnalysisStatus;
  creditInsights?: CreditInsights;
  scores?: Scores;
  error?: AnalysisError;
}

export type AnalysisBounds = [Date, Date];

export enum AnalysisConfigurationMode {
  DAYS = 'DAYS',
  MONTHS_TRUNCATED = 'MONTHS_TRUNCATED',
  MONTHS_AND_CURRENT = 'MONTHS_AND_CURRENT',
  CUSTOM_WINDOW = 'CUSTOM_WINDOW',
}

export interface AnalysisInformation {
  aggregationPeriodStart: Date | null;
  aggregationPeriodEnd: Date | null;
  totalDaysForAggregationPeriod: number;
  totalDaysOfAnalysis?: number;
  numberOfMonths?: number;
  analysisMode: AnalysisConfigurationMode;
  maxWindowDate: Date | null;
  minWindowDate: Date | null;
  referenceDate?: Date | null;
}

export enum AnalysesErrorMessages {
  TECHNICAL_ERROR = 'TECHNICAL_ERROR',
  NOT_ENOUGH_TRANSACTIONS = 'NOT_ENOUGH_TRANSACTIONS',
  CURRENCY_NOT_SUPPORTED = 'CURRENCY_NOT_SUPPORTED',
  OWNERSHIP_NOT_SUPPORTED = 'OWNERSHIP_NOT_SUPPORTED',
  USAGE_NOT_SUPPORTED = 'USAGE_NOT_SUPPORTED',
  NO_CHECKING_ACCOUNT = 'NO_CHECKING_ACCOUNT',
  NO_ANALYSES = 'NO_ANALYSES',
  AGGREGATION_FAILED = 'AGGREGATION_FAILED',
  AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED',
  LOW_ACTIVITY_SCORE = 'LOW_ACTIVITY_SCORE',
  ZERO_INCOME = 'ZERO_INCOME',
}
